var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.69 1.572a1.5 1.5 0 0 1 2.62 0l4.296 7.698a1.5 1.5 0 0 1-1.31 2.23H1.704a1.5 1.5 0 0 1-1.31-2.23zm1.747.487a.5.5 0 0 0-.874 0L1.267 9.757a.5.5 0 0 0 .436.744h8.594a.5.5 0 0 0 .436-.744zM6 3.501a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0V4a.5.5 0 0 1 .5-.5m.5 5a.5.5 0 1 0-1 0v1a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgAlertsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjY5MDE5IDEuNTcxNjlDNS4yNjI0MyAwLjU0NjQxOSA2LjczNzU0IDAuNTQ2NDE2IDcuMzA5NzggMS41NzE2OEwxMS42MDY0IDkuMjY5ODRDMTIuMTY0NSAxMC4yNjk3IDExLjQ0MTcgMTEuNTAwOSAxMC4yOTY2IDExLjUwMDlIMS43MDMzNEMwLjU1ODMwNCAxMS41MDA5IC0wLjE2NDUwOSAxMC4yNjk3IDAuMzkzNTQzIDkuMjY5ODRMNC42OTAxOSAxLjU3MTY5Wk02LjQzNjU4IDIuMDU5MDVDNi4yNDU4NCAxLjcxNzMgNS43NTQxMyAxLjcxNzMgNS41NjMzOCAyLjA1OTA1TDEuMjY2NzQgOS43NTcyMUMxLjA4MDcyIDEwLjA5MDUgMS4zMjE2NiAxMC41MDA5IDEuNzAzMzQgMTAuNTAwOUgxMC4yOTY2QzEwLjY3ODMgMTAuNTAwOSAxMC45MTkyIDEwLjA5MDUgMTAuNzMzMiA5Ljc1NzIxTDYuNDM2NTggMi4wNTkwNVpNNS45OTk5OCAzLjUwMDg5QzYuMjc2MTMgMy41MDA4OSA2LjQ5OTk4IDMuNzI0NzUgNi40OTk5OCA0LjAwMDg5VjcuMDAwODlDNi40OTk5OCA3LjI3NzAzIDYuMjc2MTMgNy41MDA4OSA1Ljk5OTk4IDcuNTAwODlDNS43MjM4NCA3LjUwMDg5IDUuNDk5OTggNy4yNzcwMyA1LjQ5OTk4IDcuMDAwODlWNC4wMDA4OUM1LjQ5OTk4IDMuNzI0NzUgNS43MjM4NCAzLjUwMDg5IDUuOTk5OTggMy41MDA4OVpNNi40OTk5OCA4LjUwMDg5QzYuNDk5OTggOC4yMjQ3NSA2LjI3NjEzIDguMDAwODkgNS45OTk5OCA4LjAwMDg5QzUuNzIzODQgOC4wMDA4OSA1LjQ5OTk4IDguMjI0NzUgNS40OTk5OCA4LjUwMDg5VjkuNTAwODlDNS40OTk5OCA5Ljc3NzAzIDUuNzIzODQgMTAuMDAwOSA1Ljk5OTk4IDEwLjAwMDlDNi4yNzYxMyAxMC4wMDA5IDYuNDk5OTggOS43NzcwMyA2LjQ5OTk4IDkuNTAwODlWOC41MDA4OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";